import { createReducer, on } from '@ngrx/store';

import { seEnvironmentSet } from './environment.actions';
import { environmentInitialState } from './environment.state';

export const environmentReducer = createReducer(
    environmentInitialState,
    on(seEnvironmentSet, (state, { env }) => ({
        ...state,
        ...env,
    })),
);
